<template>
  <div class="home-menus-box">
    <div style="padding: 6px;">
        <ul>
          <div v-for="(item,index) in menu" :key="index">
            <li  @click="$router.push({ name: item.key});" v-if="item.key != 'proxy'" :style="safeUsr.isagent == 1 ? 'width: 20%;':'width: 25%;'">
                <div class="dot" v-if="item.key == 'active' &&  (safeUsr.wheel_times > 0)" />
                <img :src="item.icon" />
                <p>{{ item.label }}</p>
            </li>
            <li  @click="$router.push({ name: item.key});" v-else-if="item.key == 'proxy' && safeUsr.isagent == 1" :style="safeUsr.isagent == 1 ? 'width: 20%;':'width: 25%;'">
                <div class="dot" v-if="item.key == 'proxy' &&  (safeUsr.red_dot == 1)" />
                <img :src="item.icon" />
                <p>{{ item.label }}</p>
            </li>
            
            </div>
        </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeGridView',
  props:['usr'],
  computed:{
    safeUsr(){
      return this.usr || {}
    }
  },
  data(){
    return {
        menu:[
            {key:'recharge',label: this.$t('menu.recharge'),icon:require('@/assets/images/homegrid/1.png')},
            {key:'withdraw',label: this.$t('menu.withdraw'),icon:require('@/assets/images/homegrid/2.png')},
            {key:'active',label: this.$t('menu.active'),icon:require('@/assets/images/homegrid/3.png')},
            {key:'proxy',label: '代理',icon:require('@/assets/images/homegrid/4.png')},
            {key:'income',label: this.$t('menu.income'),icon:require('@/assets/images/homegrid/5.png')}
            
        ],
        money1:0,
        money2:0,
        money3:0,
    }
  },
  mounted(){
  },
  methods:{
    // 外水
    async UserFanshuiInfo () {
      await this.$http({
        method: 'post',
        url: 'getUserFanshuiInfo'
      }).then(data => {
        this.waishui = data.data
        this.money1 = data.data.outfansbalance
      })
    },
    // 反水
    async FanshuiSummary () {
      await this.$http({
        method: 'post',
        url: 'getFanshuiSummary'
      }).then(data => {
        this.fanshui = data.data
        this.money2 = data.data.remaining_fanshui
        
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.home-menus-box{
    width: 98%;
    margin: 0 auto;
    background-image: url('../../../assets/images/jgq-bj.png');
    background-repeat: no-repeat;
    background-size: 100%;
    height: 2.5rem;
    ul{
        width: 100%;
        li {
            float: left;
            color: #fff;
            padding: .25rem 0;
            position: relative;
            img {
                width: 60%;
            }
            p {
                line-height: .4;
                font-size: .3rem;
            }
            .dot{
                width: 12px;
                height: 12px;
                background: #ee0a24;
                border: 1px solid #fff;
                border-radius: 6px;
                position: absolute;
                top: 10px;
                right: 20px;
            }
        }
    }
}
</style>
<style lang="scss">
.van-badge--fixed{
    top:5px !important;
    right: 18px !important;
}
</style>
